import useIsomorphicEffect from './useIsomorphicEffect';

interface GtmConfig {
  gtmId: string;
  auth: string;
  preview: string;
  scriptUrl: string;
}

export const GOOGLE_GTM_SCRIPT_URL = 'https://www.googletagmanager.com/gtm.js';
export const LIVE_GTM_SCRIPT_URL = 'https://id.haven.com/first/cdn/gtm/gtm.js';
export const DEV_GTM_SCRIPT_URL = 'https://id.haven-dev.com/first/cdn/gtm/gtm.js';

const DEV_GTM_PROPS = {
  gtmId: 'GTM-TKVRPWB5',
  auth: 'OK0NHgkeEWDynzDNWYF-eg',
  preview: 'env-4',
} as const;

const LIVE_GTM_PROPS = {
  gtmId: 'GTM-TKVRPWB5',
  auth: 'z5dVPstPlQa_Mlf3Gx7Usg',
  preview: 'env-3',
} as const;

const E2E_GTM_PROPS = {
  gtmId: 'GTM-XXXXX',
  auth: '--',
  preview: 'env-local',
} as const;

// The first-party GTM proxy only routes id.haven.com and id.haven-dev.com; other hosts load from Google.
const GTM_CONFIG_BY_HOST = new Map<string, GtmConfig>([
  ['id.haven.com', { ...LIVE_GTM_PROPS, scriptUrl: LIVE_GTM_SCRIPT_URL }],
  ['id.haven-dev.com', { ...DEV_GTM_PROPS, scriptUrl: DEV_GTM_SCRIPT_URL }],
  ['devprodid.haven.com', { ...DEV_GTM_PROPS, scriptUrl: GOOGLE_GTM_SCRIPT_URL }],
  ['id.haven-local.com', { ...E2E_GTM_PROPS, scriptUrl: GOOGLE_GTM_SCRIPT_URL }],
  ['identity.haven-local.com', { ...E2E_GTM_PROPS, scriptUrl: GOOGLE_GTM_SCRIPT_URL }],
]);

const loadGtmContainer = ({ gtmId, auth, preview, scriptUrl }: GtmConfig): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const query = new URLSearchParams({
    id: gtmId,
    gtm_auth: auth,
    gtm_preview: preview,
    gtm_cookies_win: 'x',
  });
  const script = document.createElement('script');
  script.async = true;
  script.src = `${scriptUrl}?${query.toString()}`;
  document.head.prepend(script);
};

export const useInitializeGTM = (): void => {
  useIsomorphicEffect(() => {
    const gtmConfig = GTM_CONFIG_BY_HOST.get(window.location.host);

    if (!gtmConfig) return;
    loadGtmContainer(gtmConfig);
  }, []);
};
